<template>
    <div class="root">
        <TableBlock ref="tableData" :columns="cloumn" :action="action" :param="param" :navHeight="270">
            <div class="common-space-between" style="margin-bottom:10px;">
                <div class="common-items-center">

                    <!-- <InputBlock :showBlock="false" :width="300" >
                        <el-input v-model="param.keywords"  style="margin-left:7px;" :size="this.$store.state.btnSize" placeholder="账户名称,产品名称"></el-input>
                    </InputBlock> -->
                </div>
            </div>
            <div class="common-space-between">
                <div class="common-items-center">
                    <InputBlock title="系统名称" :width="150">
                        <el-select v-model="param.belongToType" placeholder="请选择账户类型" :size="this.$store.state.btnSize">
                            <el-option v-for="item in this.$store.state.conText.accountTypeList" :key="item.val" :label="item.title" :value="item.val" />
                        </el-select>
                    </InputBlock>
                    <InputBlock title="客服端类型" :width="150">
                        <el-select v-model="param.clientType" placeholder="请选择账户类型" :size="this.$store.state.btnSize">
                            <el-option v-for="item in this.$store.state.conText.clientList" :key="item.val" :label="item.title" :value="item.val" />
                        </el-select>
                    </InputBlock>
                    <Month title="发生时间" ref="mouth" :width="150" @getDate="getDate"></Month>
                    <el-button class="btn-heigth" type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"   @click="searchBtn">搜索</el-button>
                    <el-button class="btn-heigth" type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn">重置</el-button>
                </div>
            </div>
        </TableBlock>
    </div>
</template>
  
<script>
import { operate } from '@/utils/config'
import { columns } from './index.js'
import { exportFun } from '@/utils/httpFun'
import Month from '@/components/component-block/block-month.vue'
export default {
    components: {
        Month: Month
    },
    data() {
        return {
            cloumn: [],
            action: operate.LOGAPP,
            param: {
                publishDateEnd:"",
                publishDateStart:"",
                clientType:"",
                belongToType:""
            }
        };
    },
    created() {
        this.cloumn = columns(this);
    },
    mounted() {

    },
    methods: {

        searchBtn(){
           this.$refs.tableData.getDatas()
        },
        resetBtn(){
            this.param.clientType=""
            this.param.belongToType=""
            this.param.publishDateStart=""
            this.param.publishDateEnd=""
            this.$refs.mouth.clear()
            this.$refs.tableData.resetHttp()  
        },
        //获取时间
        getDate(ev) {
            this.param.publishDateStart = ev.startDate==''?'':ev.startDate+" 00:00:00"
            this.param.publishDateEnd = ev.endDate==''?'':ev.endDate+" 23:59:59"
        },
        //导出
        exportBtn(){
            exportFun(operate.EXPORSEVER,this.param,"服务费充值记录")
        }
    }
}
</script>
  
<style lang="scss" scoped></style>